<template>
  <span class="datecontrast">
    <DatePicker
      :value="startDate"
      :clearable="false"
      :placeholder="placeholder"
      :picker-options="startPickerOptions"
      @input="handleStartChange"
    />
    <span class="datecontrast__text">对比</span>
    <DatePicker
      :value="endDate"
      :clearable="false"
      :placeholder="placeholder"
      :picker-options="endPickerOptions"
      @input="handleEndChange"
    />
  </span>
</template>

<script>
import { DatePicker, Message } from 'element-ui';
import moment from 'moment';
import shortcuts from '@/config/shortcuts';
// import shortcuts from './shortcuts';

export default {
  components: {
    DatePicker,
  },

  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    value: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      startDate: this.value[0],
      endDate: this.value[1],
      placeholder: '选择时间',
    };
  },

  computed: {
    startPickerOptions() {
      const that = this;
      return {
        disabledDate(time) {
          const t = time.getTime();
          return (
            that.isDefaultDisabledDate(t) ||
            t ===
              moment(that.endDate)
                .startOf('day')
                .valueOf()
          );
        },
        shortcuts: [
          {
            text: shortcuts.yesterday.text,
            onClick(picker) {
              const date = shortcuts.yesterday.data[0];
              if (
                date.format('YYYY-MM-DD') === that.endDate.format('YYYY-MM-DD')
              ) {
                Message.error('不能选择同一天');
              } else {
                picker.$emit('pick', date);
              }
            },
          },
          {
            text: shortcuts.dayBeforeYesterday.text,
            onClick(picker) {
              const date = shortcuts.dayBeforeYesterday.data[0];
              if (
                date.format('YYYY-MM-DD') === that.endDate.format('YYYY-MM-DD')
              ) {
                Message.error('不能选择同一天');
              } else {
                picker.$emit('pick', date);
              }
            },
          },
          {
            text: '上周本日',
            onClick(picker) {
              const date = moment().subtract(7, 'day');
              picker.$emit('pick', date);
            },
          },
        ],
      };
    },

    endPickerOptions() {
      const that = this;
      return {
        disabledDate(time) {
          const t = time.getTime();
          return (
            that.isDefaultDisabledDate(t) ||
            t ===
              moment(that.startDate)
                .startOf('day')
                .valueOf()
          );
        },

        shortcuts: [
          {
            text: shortcuts.yesterday.text,
            onClick(picker) {
              const date = shortcuts.yesterday.data[0];
              if (
                date.format('YYYY-MM-DD') ===
                that.startDate.format('YYYY-MM-DD')
              ) {
                Message.error('不能选择同一天');
              } else {
                picker.$emit('pick', date);
              }
            },
          },
          {
            text: shortcuts.dayBeforeYesterday.text,
            onClick(picker) {
              const date = shortcuts.dayBeforeYesterday.data[0];
              if (
                date.format('YYYY-MM-DD') ===
                that.startDate.format('YYYY-MM-DD')
              ) {
                Message.error('不能选择同一天');
              } else {
                picker.$emit('pick', date);
              }
            },
          },
          {
            text: '上周本日',
            onClick(picker) {
              const date = moment().subtract(7, 'day');
              picker.$emit('pick', date);
            },
          },
        ],
      };
    },
  },

  methods: {
    isDefaultDisabledDate(time) {
      return (
        time >=
        moment()
          .startOf('day')
          .valueOf()
      );
    },

    handleStartChange(e) {
      const start = moment(e);
      const end = moment(this.endDate);
      if (start.isSame(end)) {
        Message.error('不能选择相同的时间');
      } else {
        this.startDate = start;
        this.$emit('change', [start, end]);
      }
    },

    handleEndChange(e) {
      const end = moment(e);
      const start = moment(this.startDate);
      if (end.isSame(start)) {
        Message.error('不能选择相同的时间');
      } else {
        this.endDate = end;
        this.$emit('change', [start, end]);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.datecontrast {
  &__text {
    font-size: 14px;
    font-weight: 400;
    color: rgba(48, 49, 51, 1);
    margin: 0 24px;
  }
}
</style>